import PaginatedStore from "./base/PaginatedStore";
import endpoints from "../services/endpoint";

export const DEFAULT_SORT = { name: "asc" };
//TODO: Endpoint
const CLIENT_GROUPS_MANAGED_STORAGE_KEY = `/api/client-groups${endpoints("managed_list")}`;

const { store, fetchList, reset, setFilters, setHiddenColumns, setLoading, setPageIndex, setPagingInfo, setPerPage, setSort } = PaginatedStore({
    key: "clientGroupsManaged",
    label: "Client Groups Managed",
    apiListUrl: CLIENT_GROUPS_MANAGED_STORAGE_KEY,
    defaultSort: DEFAULT_SORT,
    persistPagingInfo: false,
    storageKey: CLIENT_GROUPS_MANAGED_STORAGE_KEY,
});

export const ClientGroupsManagedStore = store;

export const fetchClientGroupsManaged = fetchList;

export { reset, setFilters, setHiddenColumns, setLoading, setPageIndex, setPagingInfo, setPerPage, setSort };
